import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Alert, Button, Card, Field, Input, Screen, Select, Stack } from '../components';
import { ChevronLeftIcon } from '../components/icons';
import { CURRENCIES } from '../lib/money';
import { createTrip } from '../data/trips';
import { useSubmit } from '../hooks/useSubmit';

export function NewTripPage() {
  const navigate = useNavigate();
  const submit = useSubmit();

  const [name, setName] = useState('');
  const [baseCurrency, setBaseCurrency] = useState('CAD');
  const [localCurrency, setLocalCurrency] = useState('CNY');
  const [startsOn, setStartsOn] = useState('');
  const [endsOn, setEndsOn] = useState('');

  async function handleSubmit(event: React.FormEvent) {
    event.preventDefault();
    if (!name.trim()) return;

    let created: string | null = null;
    const ok = await submit.run(async () => {
      const trip = await createTrip({
        name,
        baseCurrency,
        localCurrency: localCurrency || null,
        startsOn: startsOn || null,
        endsOn: endsOn || null,
      });
      created = trip.id;
    });

    if (ok && created) navigate(`/trips/${created}`, { replace: true });
  }

  return (
    <Screen maxWidth={460}>
      <Stack gap={5}>
        <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: 4, color: 'var(--text-secondary)' }}>
          <ChevronLeftIcon size={16} />
          Your trips
        </Link>

        <h1 style={{ fontSize: 'var(--fs-h1)' }}>New trip</h1>

        <Card>
          <form onSubmit={handleSubmit} noValidate>
            <Stack gap={4}>
              {submit.error && <Alert tone="error">{submit.error}</Alert>}

              <Field label="Trip name">
                {({ id }) => (
                  <Input
                    id={id}
                    autoFocus
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="China trip"
                  />
                )}
              </Field>

              <div style={{ display: 'flex', gap: 'var(--sp-3)' }}>
                <div style={{ flex: 1 }}>
                  <Field label="Home currency" hint="Balances are shown in this.">
                    {({ id }) => (
                      <Select id={id} value={baseCurrency} onChange={(e) => setBaseCurrency(e.target.value)}>
                        {CURRENCIES.map((c) => (
                          <option key={c.code} value={c.code}>
                            {c.code}
                          </option>
                        ))}
                      </Select>
                    )}
                  </Field>
                </div>
                <div style={{ flex: 1 }}>
                  <Field label="Spending in" hint="The default for new expenses.">
                    {({ id }) => (
                      <Select id={id} value={localCurrency} onChange={(e) => setLocalCurrency(e.target.value)}>
                        {CURRENCIES.map((c) => (
                          <option key={c.code} value={c.code}>
                            {c.code}
                          </option>
                        ))}
                      </Select>
                    )}
                  </Field>
                </div>
              </div>

              <div style={{ display: 'flex', gap: 'var(--sp-3)' }}>
                <div style={{ flex: 1 }}>
                  <Field label="Starts">
                    {({ id }) => (
                      <Input id={id} type="date" value={startsOn} onChange={(e) => setStartsOn(e.target.value)} />
                    )}
                  </Field>
                </div>
                <div style={{ flex: 1 }}>
                  <Field label="Ends">
                    {({ id }) => (
                      <Input id={id} type="date" value={endsOn} onChange={(e) => setEndsOn(e.target.value)} />
                    )}
                  </Field>
                </div>
              </div>

              <Button type="submit" size="lg" fullWidth loading={submit.submitting} disabled={!name.trim()}>
                Create trip
              </Button>

              <p style={{ color: 'var(--text-muted)', fontSize: 'var(--fs-body-sm)' }}>
                You will get an invite code to share. The home currency locks once anyone adds an
                expense, because every amount is converted and stored against it.
              </p>
            </Stack>
          </form>
        </Card>
      </Stack>
    </Screen>
  );
}
